
import worker from "../../lib/plugin/worker.js"

worker(window._hyperscript)

